import { render, staticRenderFns } from "./LaboratoryAdd.vue?vue&type=template&id=1a79fb87"
import script from "./LaboratoryAdd.vue?vue&type=script&lang=js"
export * from "./LaboratoryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports